import {
  LIST_STORED_WORKSPACES_ROUTE,
  GET_STORED_WORKSPACE_ROUTE,
  CREATE_STORED_WORKSPACE_ROUTE,
  UPDATE_STORED_WORKSPACE_ROUTE,
  DELETE_STORED_WORKSPACE_ROUTE,
} from '../../handlers/stored-workspaces';

export const STORED_WORKSPACES_ROUTES = [
  // Stored Workspaces CRUD Routes
  LIST_STORED_WORKSPACES_ROUTE,
  GET_STORED_WORKSPACE_ROUTE,
  CREATE_STORED_WORKSPACE_ROUTE,
  UPDATE_STORED_WORKSPACE_ROUTE,
  DELETE_STORED_WORKSPACE_ROUTE,
] as const;
